<div class="vertical-line">

</div>



<div class="reservation_step">
  <ul>
    <li routerLinkActive="active" class="left-link">

      <span>1.</span> Personal
    </li>
    <li>

      <span>2.</span> Conference
    </li>
    <li>

      <span>3.</span> Accommodation
    </li>
    <li>

      <span>4.</span> Room Choice
    </li>
    <li>

      <span>5.</span> Tour
    </li>
    <li class="right-link active">

      <span>6.</span> Confirm
    </li>
  </ul>
</div>
<div class="row">
  <p>
    Please CONFIRM BOOKING to submit or cancel.
  </p>

  <!-- <p class="text-center" *ngIf="!(enableConfirmButton$ | async)" style="color: red;">
    Please go back and at least fill your first names, last name and some amounts.
  </p> -->
  <div>
    <button class="btn btn-info pull-left" [disabled]="disableConfirmButton" (click)="addBooking()">Confirm Booking</button>
    <!-- <button class="btn btn-success" (click)="goBack()"> Go Back</button> -->
    <button class="btn btn-success pull-right" (click)="cancel()"> Cancel</button>
  </div>
</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/confirmation/confirmation.component.html